import { render, staticRenderFns } from "./shop-dialog-selector-instance.vue?vue&type=template&id=32ed2ef6&"
import script from "./shop-dialog-selector-instance.vue?vue&type=script&lang=js&"
export * from "./shop-dialog-selector-instance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports